import Vue from 'vue';
import Vuex from 'vuex';
import prefetcher from '@ibiquity/dashboard.prefetcher';
import playback from './broadcastsPlayback';
import customMarket from './customMarket';
import markets from './markets';
import setup from './setup';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    playback,
    customMarket,
    setup,
    markets,
    prefetcher,
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
